// function 提供有多重燈號的表格使用
// TBROC: scenic_area_alert scenic_area_management
// NTPC: coastal_warning
// THSR: thsr_monitor

const _get_icon_color = (datum, key, icons) => {
    const alert_level = datum[key]['燈號']
    const color_by_level = icons[key][alert_level]?.color
    if (color_by_level) {
        return `multiple-signal--${color_by_level}`
    } 

    return `multiple-signal--${icons[key]['color']}`
}

export const generate_sign_icon_html = (datum, icons) => {
    const icons_array = Object.keys(icons)
    return Object.keys(datum)
        .filter(key => icons_array.includes(key))
        .sort((a, b) => icons_array.indexOf(a) - icons_array.indexOf(b))
        .reduce((accumulator, key) => { 
            const icon_name = icons[key]['name']                
            if (icon_name && datum[key]['燈號']) {
                const icon_color = _get_icon_color(datum, key, icons)
                return [...accumulator, `<i class="v-icon ${icon_name} ${icon_color}"></i>`]
            }  
            
            if (icons[key]['show_opacity']) {
                return [...accumulator, '-']
            }
            
            return accumulator
        }, [])
}

export const reconstruct_alert_icon = (data, icons) => {
    const icons_array = Object.keys(icons)
    const new_data = data.map(datum => {
        const new_datum = {
            '警示': [],
            'alert_order': 0,
        }
        Object.keys(datum)
            .filter(key => icons_array.includes(key))
            .sort((a, b) => icons_array.indexOf(a) - icons_array.indexOf(b))
            .forEach(key => {
                const icon_name = icons[key]['name']
                if (icon_name && datum[key]['燈號']) {
                    const icon_color = _get_icon_color(datum, key, icons)
                    new_datum['警示'].push({
                        'html': `<i class="v-icon ${icon_name} ${icon_color}"></i>`,
                        'tooltip_content': datum[key]['理由']
                    })
                    new_datum['alert_order'] -= 1
                } else if (icons[key]['show_opacity']) {
                    new_datum['警示'].push({
                        'html': `<i class="v-icon ${icon_name} multiple-signal--gray"></i>`,
                        'tooltip_content': datum[key]['條件']
                    })
                }
            }) 
        return { ...datum, ...new_datum }
    })

    return new_data
}